<template>
	<div>
		<div class="d-flex justify-space-between">
			<h2 class="mb-4">Booth Design Library</h2>
			<v-btn color="primary" @click="showAdd()">Add Booth Design</v-btn>
		</div>

		<v-row>
			<v-col cols="3">
				<v-autocomplete
					v-model="planFilter"
					chips
					small-chips
					deletable-chips
					label="Filter by plans"
					multiple
					:items="tenantPlanList"
					item-value="id"
					:item-text="(item) => item.name + ' - ' + item.type"
					solo
					dense
				></v-autocomplete>
			</v-col>
			<v-col cols="3">
				<v-autocomplete
					v-model="tagFilter"
					:items="tagList"
					chips
					small-chips
					deletable-chips
					label="Filter by tags"
					multiple
					solo
					dense
				></v-autocomplete>
			</v-col>
			<div style="display:flex;flex-direction:row;margin-top:13px;">
				<v-btn color="primary" style="margin-right:10px;" @click="listLayout">filter</v-btn>
				<v-btn color="primary" @click="resetFilter">Reset</v-btn>
			</div>
		</v-row>

		<div class="d-flex flex-wrap justify-space-around align-stretch">
			<v-hover v-for="(entity, index) in layoutList.data" :key="index" v-slot:default="{ hover }">
				<v-card :elevation="hover ? 4 : 2" width="340" class="mb-5">
					<v-card-title>
						<span>{{ entity.name }}</span>
						<v-spacer></v-spacer>
					</v-card-title>
					<div id="structure-view" style="display: block">
						<div class="entry-view" v-if="entity.dataMap && entity.dataMap.value">
							<v-img
								v-if="$root.isImage(entity.dataMap.value)"
								:src="$root.asset(entity.dataMap.value)"
								max-height="200"
								min-height="200"
							></v-img>
							<video
								v-else-if="$root.isVideo(entity.dataMap.value)"
								width="100%"
								style="max-height: 200px; min-height: 200px"
								preload="auto"
								autoplay="autoplay"
								muted
								playsinline
								disablepictureinpicture
								loop="loop"
							>
								<source :src="$root.asset(entity.dataMap.value)" type="video/mp4" />
							</video>
						</div>
					</div>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" @click="showEdit(entity)">
									<v-icon>mdi-pencil</v-icon>
								</v-btn>
							</template>
							<span>Edit Booth Design</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" @click="showBannerData(entity)">
									<v-icon>mdi-link-variant-plus</v-icon>
								</v-btn>
							</template>
							<span>Banner Data</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn icon v-bind="attrs" v-on="on" @click="deleteLayoutLibrary(entity.id)">
									<v-icon color="red">mdi-delete</v-icon>
								</v-btn>
							</template>
							<span>Delete Booth Design</span>
						</v-tooltip>
					</v-card-actions>
				</v-card>
			</v-hover>
		</div>

		<div class="d-flex flex-wrap justify-space-between" style="margin: 0px 20px 0px 30px">
			<div class="d-inline-flex">
				<span style="margin-top: 10px"> Rows per page : </span>
				<v-select
					v-model="layoutList.size"
					:items="rowsPerPage"
					style="margin-left: 10px; width: 80px"
					@change="listLayout()"
					hide-details=""
					solo
				></v-select>
			</div>

			<v-pagination
				v-model="layoutList.page"
				:length="layoutList.length"
				:total-visible="7"
				@input="listLayout()"
			></v-pagination>
		</div>

		<v-dialog v-model="dialogAdd" v-if="dialogAdd" persistent no-click-animation fullscreen hide-overlay transition="dialog-bottom-transition">
			<v-card>
				<v-card-title class="headline">
					Add Booth Design Library
					<v-spacer></v-spacer>
					<v-btn icon @click="closeAdd()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-row class="d-flex justify-center">
						<v-col cols="7">
							<v-form ref="formAdd" v-model="valid" @submit.prevent="addLayoutLibrary">
								<div id="structure-view" style="display: block" class="mb-5">
									<v-row class="entry-view">
										<v-col ref="box" id="box">
											<img
												v-if="
													backgroundTemp &&
													backgroundTemp.startsWith('data') &&
													backgroundType == 'Upload' &&
													(backgroundImageName.toLowerCase().endsWith('.jpg') ||
														backgroundImageName.toLowerCase().endsWith('.jpeg') ||
														backgroundImageName.toLowerCase().endsWith('.png'))
												"
												:src="backgroundTemp"
												width="100%"
												height="550px"
											/>
											<img
												v-else-if="
													entity &&
													entity.dataMap &&
													entity.dataMap.value &&
													backgroundType == 'URL' &&
													$root.isImage(entity.dataMap.value)
												"
												:src="
													entity.dataMap.value.toLowerCase().startsWith('http')
														? entity.dataMap.value
														: baseLocation + '/asset/file/' + entity.dataMap.value
												"
												width="100%"
												height="550px"
											/>

											<video
												v-else-if="
													backgroundTemp &&
													backgroundTemp.startsWith('data') &&
													backgroundImageName.toLowerCase().endsWith('.mp4')
												"
												width="100%"
												height="550px"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source :src="backgroundTemp" type="video/mp4" />
											</video>
											<video
												v-else-if="entity && entity.dataMap && entity.dataMap.value && $root.isVideo(entity.dataMap.value)"
												width="100%"
												height="550px"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source
													:src="
														entity.dataMap.value.toLowerCase().startsWith('http')
															? entity.dataMap.value
															: baseLocation + '/asset/file/' + entity.dataMap.value
													"
													type="video/mp4"
												/>
											</video>
											<div v-else style="border: 5px solid black; width: 100%; height: 550px"></div>
											<!--- INPUT BACKGROUND-->
											<v-row>
												<v-col cols="12" sm="3">
													<v-select v-model="backgroundType" :items="['Upload', 'URL']" label="Design Type"></v-select>
												</v-col>
												<v-col cols="12" sm="9" v-if="backgroundType === 'Upload'">
													<input
														ref="attachment1"
														type="file"
														accept="image/png, image/jpeg, image/jpg, video/mp4"
														@change="onBackgroundUpload"
														style="display: none"
													/>
													<v-text-field
														v-model="backgroundFileName"
														label="Design"
														hint="It’s recommended to use image with resolution approximately 1920x1080 pixels and recommended size is under 2MB, and for video it's recommended to use resolution of 1080 pixels."
														placeholder="Upload Design"
														prepend-icon="mdi-image"
														@click="openBackgroundDialog()"
														readonly
														:rules="[(v) => !!v || 'Booth design image is required']"
													>
													</v-text-field>
												</v-col>
												<v-col cols="12" sm="9" v-else>
													<v-text-field
														v-model="entity.dataMap.value"
														prepend-icon="mdi-image"
														label="Design"
														placeholder="Design Url"
														hint="Please input image url with jpeg/jpg/png extension"
														:rules="[(v) => !!v || 'Booth design image is required']"
													></v-text-field> </v-col
											></v-row>
											<!-- END OF INPUT BACKGROUND-->
										</v-col>
									</v-row>
								</div>
								<v-row>
									<v-col cols="12">
										<v-text-field
											v-model="entity.name"
											label="Name"
											:rules="[(v) => !!v || 'Name is required']"
											@input="entity.slug = entity.name ? entity.name.toLowerCase().replace(' ', '') : null"
											prepend-icon="mdi-home"
											dense
										></v-text-field>
									</v-col>
									<v-col cols="12">
										<v-combobox
											v-model="entity.tagList"
											:items="tagList"
											label="Select a tag or create a new one"
											multiple
											small-chips
											deletable-chips
										></v-combobox>
									</v-col>
									<v-col cols="12">
										<v-checkbox v-model="isTargetOne" label="This library only for 1 tenant"></v-checkbox>
									</v-col>
									<v-col cols="12" v-if="isTargetOne">
										<v-autocomplete
											v-model="entity.targetId"
											label="Tenant"
											:rules="[(v) => !!v || 'This field is required']"
											:items="tenantList"
											item-text="name"
											item-value="id"
										>
										</v-autocomplete>
									</v-col>
									<v-col cols="12" v-else>
										<v-select
											v-model="entity.planList"
											label="Membership Plan"
											:rules="[(v) => !!v.length > 0 || 'This field is required']"
											multiple
											chips
											:items="tenantPlanList"
											item-value="id"
											:item-text="(item) => item.name + ' - ' + item.type"
										>
											<template v-slot:selection="{ item }" :default="entity.planList">
												<v-chip color="primary" dark small> {{ item.name }} - {{ item.type }}</v-chip>
											</template>
										</v-select>
									</v-col>
								</v-row>
								<div class="d-flex justify-end">
									<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
								</div>
							</v-form>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogEdit" v-if="dialogEdit" persistent no-click-animation fullscreen hide-overlay transition="dialog-bottom-transition">
			<v-card>
				<v-card-title class="headline">
					Edit Booth Design Library
					<v-spacer></v-spacer>
					<v-btn icon @click="closeEdit()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-row class="d-flex justify-center">
						<v-col cols="7">
							<v-form ref="formEdit" v-model="validEdit" @submit.prevent="editLayoutLibrary">
								<div id="structure-view" style="display: block" class="mb-5">
									<v-row class="entry-view">
										<v-col ref="box" id="box">
											<img
												v-if="
													editBackgroundTemp &&
													editBackgroundTemp.startsWith('data') &&
													(backgroundImageName.toLowerCase().endsWith('.jpg') ||
														backgroundImageName.toLowerCase().endsWith('.jpeg') ||
														backgroundImageName.toLowerCase().endsWith('.png'))
												"
												:src="editBackgroundTemp"
												width="100%"
												height="550px"
											/>
											<img
												v-else-if="
													entityEdit &&
													entityEdit.dataMap &&
													entityEdit.dataMap.value &&
													$root.isImage(entityEdit.dataMap.value)
												"
												:src="
													entityEdit.dataMap.value.toLowerCase().startsWith('http')
														? entityEdit.dataMap.value
														: baseLocation + '/asset/file/' + entityEdit.dataMap.value
												"
												width="100%"
												height="550px"
											/>

											<video
												v-else-if="
													editBackgroundTemp &&
													editBackgroundTemp.startsWith('data') &&
													backgroundImageName.toLowerCase().endsWith('.mp4')
												"
												width="100%"
												height="550px"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source :src="editBackgroundTemp" type="video/mp4" />
											</video>
											<video
												v-else-if="
													entityEdit &&
													entityEdit.dataMap &&
													entityEdit.dataMap.value &&
													$root.isVideo(entityEdit.dataMap.value)
												"
												width="100%"
												preload="auto"
												autoplay="autoplay"
												muted
												playsinline
												disablepictureinpicture
												loop="loop"
											>
												<source
													:src="
														entityEdit.dataMap.value.toLowerCase().startsWith('http')
															? entityEdit.dataMap.value
															: baseLocation + '/asset/file/' + entityEdit.dataMap.value
													"
													type="video/mp4"
												/>
											</video>
											<div v-else style="border: 5px solid black; width: 100%; height: 350px"></div>
											<v-row>
												<v-col cols="12" sm="3">
													<v-select v-model="backgroundType" :items="['Upload', 'URL']" label="Design Type"></v-select>
												</v-col>
												<v-col cols="12" sm="9" v-if="backgroundType === 'Upload'">
													<input
														ref="attachment1"
														type="file"
														accept="image/png, image/jpeg, image/jpg, video/mp4"
														@change="onBackgroundUpload"
														style="display: none"
													/>
													<v-text-field
														v-model="backgroundFileName"
														label="Booth Design"
														hint="It’s recommended to use image with resolution approximately 1920x1080 pixels and recommended size is under 2MB, and for video it's recommended to use resolution of 1080 pixels."
														placeholder="Upload Design"
														prepend-icon="mdi-image"
														@click="openBackgroundDialog()"
														readonly
														:rules="[(v) => !!v || 'Booth design image is required']"
													>
													</v-text-field>
												</v-col>
												<v-col cols="12" sm="9" v-else>
													<v-text-field
														v-model="entityEdit.dataMap.value"
														prepend-icon="mdi-image"
														label="Booth Design"
														placeholder="Booth Design Url"
														hint="Please input image url with jpeg/jpg/png extension"
														:rules="[(v) => !!v || 'Booth design image is required']"
													></v-text-field> </v-col
											></v-row>
										</v-col>
									</v-row>
								</div>
								<v-row>
									<v-col cols="12">
										<v-text-field
											v-model="entityEdit.name"
											label="Name"
											:rules="[(v) => !!v || 'Name is required']"
											@input="entityEdit.slug = entityEdit.name ? entityEdit.name.toLowerCase().replace(' ', '') : null"
											prepend-icon="mdi-home"
											dense
										></v-text-field>
									</v-col>
									<v-col cols="12">
										<v-combobox
											v-model="entityEdit.tagList"
											:items="tagList"
											label="Select a tag or create a new one"
											multiple
											small-chips
											deletable-chips
										></v-combobox>
									</v-col>
									<v-col cols="12">
										<v-checkbox v-model="isTargetOne" label="This library only for 1 tenant"></v-checkbox>
									</v-col>
									<v-col cols="12" v-if="isTargetOne">
										<v-autocomplete
											v-model="entityEdit.targetId"
											label="Tenant"
											:rules="[(v) => !!v || 'This field is required']"
											:items="tenantList"
											item-text="name"
											item-value="id"
										>
										</v-autocomplete>
									</v-col>
									<v-col cols="12" v-else>
										<v-select
											v-model="entityEdit.planList"
											label="Membership Plan"
											:rules="[(v) => !!v.length > 0 || 'This field is required']"
											multiple
											chips
											:items="tenantPlanList"
											item-value="id"
											:item-text="(item) => item.name + ' - ' + item.type"
										>
											<template v-slot:selection="{ item }" :default="entityEdit.planList">
												<v-chip color="primary" dark small> {{ item.name }} - {{ item.type }}</v-chip>
											</template>
										</v-select>
									</v-col>
								</v-row>
								<div class="d-flex justify-end">
									<v-btn :disabled="!validEdit" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
								</div>
							</v-form>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog
			:retain-focus="false"
			v-model="dialogBannerData"
			v-if="dialogBannerData"
			persistent
			no-click-animation
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
		>
			<v-card>
				<v-card-title class="headline">
					Add Banner Data
					<v-spacer></v-spacer>
					<v-btn icon @click="closeBannerData()">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>
					<v-row class="d-flex justify-center">
						<v-col cols="12" sm="8">
							<v-card>
								<v-card-text>
									<div id="structure-view" style="display: block">
										<div class="entry-view">
											<div @mousedown="startDrag" @mousemove="getPosition($event)" style="background-color: rgba(0, 0, 0, 0.2)" ref="box" id="box">
												<img
													v-if="
														entityEdit &&
														entityEdit.dataMap &&
														entityEdit.dataMap.value &&
														(entityEdit.dataMap.value.toLowerCase().endsWith('.jpg') ||
															entityEdit.dataMap.value.toLowerCase().endsWith('.jpeg') ||
															entityEdit.dataMap.value.toLowerCase().endsWith('.png'))
													"
													:src="
														entityEdit.dataMap.value.toLowerCase().startsWith('http')
															? entityEdit.dataMap.value
															: baseLocation + '/asset/file/' + entityEdit.dataMap.value
													"
													width="100%"
												/>
												<video
													v-else-if="
														entityEdit &&
														entityEdit.dataMap &&
														entityEdit.dataMap.value &&
														entityEdit.dataMap.value.toLowerCase().endsWith('.mp4')
													"
													width="100%"
													preload="auto"
													autoplay="autoplay"
													muted
													playsinline
													disablepictureinpicture
													loop="loop"
												>
													<source
														:src="
															entityEdit.dataMap.value.toLowerCase().startsWith('http')
																? entityEdit.background
																: baseLocation + '/asset/file/' + entityEdit.dataMap.value
														"
														type="video/mp4"
													/>
												</video>
												<div v-for="(item, index) in entityEdit.bannerList" :key="index">
													<router-link
														class="structure-link"
														to="#"
														:style="{
															zIndex: 2,
															width: item.coordinateList[2] + '%',
															height: item.coordinateList[3] + '%',
															top: item.coordinateList[1] + '%',
															left: item.coordinateList[0] + '%',
															transform: 'skew(' + item.skewX + 'deg,' + item.skewY + 'deg)',
														}"
													></router-link>
												</div>
												<router-link
													v-if="newBannerData && newBannerData.coordinateList"
													class="structure-link"
													to="#"
													:style="{
														zIndex: 2,
														backgroundColor: 'rgba(245, 229, 27, .5)',
														width: newBannerData.coordinateList[2] + '%',
														height: newBannerData.coordinateList[3] + '%',
														top: newBannerData.coordinateList[1] + '%',
														left: newBannerData.coordinateList[0] + '%',
														transform: 'skew(' + newBannerData.skewX + 'deg,' + newBannerData.skewY + 'deg)',
													}"
												></router-link>
											</div>
										</div>
									</div>
									<v-row>
										<v-col>
											<v-text-field class="mb-n9" readonly v-model="x" label="Position X (%)" dense outlined></v-text-field>
										</v-col>
										<v-col>
											<v-text-field class="mb-n9" readonly v-model="y" label="Position Y (%)" dense outlined></v-text-field>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
						</v-col>
						<v-col cols="12" sm="4">
							<v-card id="BannerData">
								<v-card-text>
									<v-row>
										<v-col cols="12" class="my-n4">
											<v-text-field v-model="newBannerData.name" label="Banner Name" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" class="my-n4">
											<v-text-field v-model="newBannerData.coordinateList[0]" label="X" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" class="my-n4">
											<v-text-field v-model="newBannerData.coordinateList[1]" label="Y" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" class="my-n4">
											<v-text-field v-model="newBannerData.coordinateList[2]" label="Width" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" class="my-n4">
											<v-text-field v-model="newBannerData.coordinateList[3]" label="Height" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" class="my-n4">
											<v-text-field v-model="newBannerData.skewX" label="Skew X" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" sm="6" class="my-n4">
											<v-text-field v-model="newBannerData.skewY" label="Skew Y" dense outlined></v-text-field>
										</v-col>
										<v-col cols="12" class="text-right">
											<v-btn
												color="primary"
												@click="
													addBannerData();
													isEditBannerData = false;
												"
												>Save</v-btn
											>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
					<v-form ref="formBannerData" v-model="validBannerData" @submit.prevent="editBoothBannerData">
						<v-card>
							<v-card-title>Banner Data</v-card-title>
							<v-card-text>
								<v-simple-table>
									<template v-slot:default>
										<thead>
											<tr v-if="entityEdit.bannerList && entityEdit.bannerList.length > 0">
												<th colspan="2">Banner Name</th>
												<th colspan="2">Position</th>
											</tr>
										</thead>
										<tbody v-if="entityEdit.bannerList && entityEdit.bannerList.length > 0">
											<tr v-for="(item, index) in entityEdit.bannerList" :key="index">
												<td>{{ item.name }}</td>
												<td>
													<v-row>{{ "W : " + item.coordinateList[2] + "% H : " + item.coordinateList[3] + "%" }}</v-row>
													<v-row>{{ "X : " + item.coordinateList[0] + "% Y : " + item.coordinateList[1] + "%" }}</v-row>
													<v-row>{{ "Skew X : " + (item.skewX ? item.skewX : "0") + " deg" }}</v-row>
													<v-row>{{ "Skew Y : " + (item.skewY ? item.skewY : "0") + " deg" }}</v-row>
												</td>
												<td>
													<v-btn @click="editBannerData(entityEdit, item.sequence)" color="primary" icon>
														<v-icon>mdi-pencil</v-icon>
													</v-btn>
													<v-btn @click="deleteBannerData(entityEdit, item.sequence)" color="red" icon>
														<v-icon>mdi-delete</v-icon>
													</v-btn>
												</td>
											</tr>
										</tbody>
										<tbody v-else>
											<tr>
												<td colspan="2">
													<v-card-text style="text-align: center">No Banner Data Found</v-card-text>
												</td>
											</tr>
										</tbody>
									</template>
								</v-simple-table>
							</v-card-text>
							<v-card-actions class="d-flex justify-end">
								<v-btn @click="closeBannerData()" text depressed tile>Close</v-btn>
								<v-btn :disabled="!validBannerData" type="submit" color="primary darken-1" depressed tile>Save</v-btn>
							</v-card-actions>
						</v-card>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<style scoped>
#structure-view .entry-view {
	max-width: 100%;
	margin: 0 auto;
}
.entry-view {
	position: relative;
}
.structure-link {
	cursor: pointer;
	position: absolute;
}
.longtext {
	max-width: 100px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
</style>

<script>
import axios from "axios";

export default {
	data() {
		return {
			valid: true,
			validEdit: true,
			validBannerData: true,
			dialogAdd: false,
			dialogEdit: false,
			dialogBannerData: false,
			layoutList: { data: [], page: 1, size: 8, length: 0, total: 0 },
			entity: { bannerList: [], planList: [] },
			entityEdit: { planList: [] },
			backgroundType: "Upload",
			attachment1: null,
			baseLocation: axios.defaults.baseURL,
			tenantPlanList: [],
			tenantList: [],
			backgroundFileName: "",
			backgroundImageName: "",
			editBackgroundTemp: "",
			backgroundTemp: "",
			isTargetOne: false,
			sequence: 0,
			newBannerData: { coordinateList: [0, 0, 0, 0], name: null },
			x: null,
			y: null,
			loading: false,
			dragging: false,
			tagList: [],
			tagFilter: [],
			planFilter: [],
			layoutAll: [],
			rowsPerPage: [8, 16, 32, 64]
		};
	},
	mounted() {
		this.listLayout();
		this.listTenantPlan();
		this.listTenant();
		this.listTag();
		window.addEventListener('mouseup', this.stopDrag);
	},
	methods: {
		listLayout() {
			axios.post("/system/layout/list", {
					planFilter: this.planFilter,
					tagFilter: this.tagFilter,
					tenantPlanId: null,
					page: this.layoutList.page,
					size: this.layoutList.size
				}).then((response) => {
				this.layoutList = response.data;
				// Check if small asset is exist and use it
				let vm = this;
				this.layoutList.data.map(obj => {
					vm.$root.isImageExist(vm.$root.smallAsset(obj.dataMap.value), function(status) {
						if (status) {
							obj.dataMap.value = vm.$root.smallAsset(obj.dataMap.value)
						}
					});
					return obj;
				});
				this.layoutAll = this.layoutList;
			});
		},
		listTag() {
			axios.get("/system/layout/tag/list").then(response => {
				this.tagList = response.data;
			});
		},
		resetFilter(){
			this.planFilter = [];
			this.tagFilter = [];
			this.layoutList.page = 1;
			this.layoutList.size = 8;
			this.listLayout();
		},
		deleteLayoutLibrary(id) {
			if (confirm("Are you sure you want to delete?")) {
				axios.post("/system/layout/delete", { id: id }).then(() => {
					this.listLayout();
				});
			}
		},
		addLayoutLibrary() {
			if (this.isTargetOne) {
				this.entity.planList = [];
			} else {
				this.entity.targetId = null;
			}
			this.entity.bannerList = [];
			let formData = new FormData();
			formData.append("entity", JSON.stringify(this.entity));
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}

			axios.post("/system/layout/add", formData).then(() => {
				this.listLayout();
				this.entity = {
					dataMap: {},
					bannerList: [],
				};
				this.closeAdd();
				this.listTag();
			});
		},
		editLayoutLibrary() {
			if (this.isTargetOne) {
				this.entityEdit.planList = [];
			} else {
				this.entityEdit.targetId = null;
			}
			let formData = new FormData();
			formData.append("entity", JSON.stringify(this.entityEdit));
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}

			axios.post("/system/layout/edit", formData).then(() => {
				this.listLayout();
				this.entityEdit = {
					dataMap: {},
					BannerDataDataList: [],
				};
				this.closeEdit();
				this.listTag();
			});
		},
		showAdd() {
			this.backgroundType = "Upload";
			this.entity = {
				dataMap: {},
			};
			this.dialogAdd = true;
		},
		showEdit(item) {
			this.entityEdit = { ...item };
			if (this.entityEdit.dataMap.value) {
				this.entityEdit.dataMap.value = this.$root.reverseToOriginal(this.entityEdit.dataMap.value);
			}
			this.isTargetOne = this.entityEdit.targetId ? true : false;
			if (this.entityEdit && this.entityEdit.dataMap && this.entityEdit.dataMap.value) {
				this.backgroundType = "URL";
			} else {
				this.backgroundType = "Upload";
			}
			this.dialogEdit = true;
		},
		showBannerData(item) {
			this.entityEdit = { ...item };
			this.dialogBannerData = true;
			if (!this.entityEdit.bannerList) {
				this.sequence = 0;
				this.entityEdit.bannerList = [];
			} else {
				this.sequence = this.entityEdit.bannerList.length;
			}
		},
		closeAdd() {
			this.entity = {};
			this.dialogAdd = false;
			this.clearData();
		},
		closeEdit() {
			this.entityEdit = {};
			this.dialogEdit = false;
			this.clearData();
		},
		closeBannerData() {
			this.entityEdit = {};
			this.newBannerData = { coordinateList: [0, 0, 0, 0] };
			this.dialogBannerData = false;
			this.clearData();
		},
		listTenantPlan() {
			axios.get("/system/tenantplan/list").then((response) => {
				this.tenantPlanList = response.data;
			});
		},
		listTenant() {
			axios.get("/system/tenant/list").then((response) => {
				this.tenantList = response.data;
			});
		},
		onBackgroundUpload(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				let imageName = files[0].name;
				if (imageName.lastIndexOf(".") <= 0) {
					return;
				}
				const fr = new FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener("load", () => {
					if (this.dialogAdd) {
						this.backgroundTemp = fr.result;
					} else {
						this.editBackgroundTemp = fr.result;
					}
					this.attachment1 = files[0]; // this is an image file that can be sent to server...
				});
				this.backgroundFileName = files[0].name + " (" + files[0].size / 1000 + "kB)";
				this.backgroundImageName = files[0].name;
			} else {
				this.attachment1 = null;
			}
		},
		openBackgroundDialog() {
			this.$refs.attachment1.click();
		},
		clearData() {
			this.attachment1 = null;
			this.backgroundFileName = "";
			this.backgroundImageName = "";
			this.editBackgroundTemp = "";
			this.backgroundTemp = "";
		},
		getPosition(event) {
			var rect = this.$refs.box.getBoundingClientRect();
			this.x = Math.round(((event.clientX - rect.left) / rect.width) * 100).toFixed(2);
			this.y = Math.round(((event.clientY - rect.top) / rect.height) * 100).toFixed(2);
			if (this.dragging) {
				event.preventDefault();
				this.newBannerData.coordinateList[2]= (this.x - this.newBannerData.coordinateList[0]).toFixed(2);
				this.newBannerData.coordinateList[3] = (this.y - this.newBannerData.coordinateList[1]).toFixed(2);
			}
		},
		startDrag() {
			this.dragging = true;
			this.newBannerData.coordinateList[0] = this.x;
			this.newBannerData.coordinateList[1] = this.y;
		},
		stopDrag() {
			this.dragging = false;
		},
		editBannerData(entity, id) {
			let list = entity.bannerList;
			for (let i in list) {
				if (list[i].sequence === id) {
					this.newBannerData = list[i];
					list.splice(i, 1);
					this.isEditBannerData = true;
					return;
				}
			}
		},
		deleteBannerData(entity, id) {
			let list = entity.bannerList;
			for (let i in list) {
				if (list[i].sequence === id) {
					list.splice(i, 1);
					return;
				}
			}
		},
		async addBannerData() {
			this.newBannerData.sequence = this.newBannerData.sequence ? this.newBannerData.sequence : ++this.sequence;
			this.entityEdit.bannerList.push(this.newBannerData);
			this.clearBannerForm();
		},
		editBoothBannerData() {
			this.entityEdit.bannerList = this.entityEdit.bannerList.sort(function (a, b) {
				if (b.sequence > a.sequence) {
					return -1;
				}
				if (b.sequence < a.sequence) {
					return 1;
				}
				return 0;
			});
			let formData = new FormData();
			formData.append("entity", JSON.stringify(this.entityEdit));
			axios
				.post("/system/layout/edit/bannerdata", formData, {
					headers: {
						"Content-Type": "multipart/form-data",
					},
				})
				.then(() => {
				});
		},
		clearBannerForm() {
			this.newBannerData = { coordinateList: [0, 0, 0, 0] };
		},
	},
};
</script>
